import React from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { IoAlertCircleOutline } from "react-icons/io5";
import { CONTACT_VERIFICATION_ROLE, getContactVerificationProfilePath, getContactVerificationPromptMessage } from "../utils/contactVerification";

const ContactVerificationPrompt = ({ open, onClose, role = CONTACT_VERIFICATION_ROLE.FAMILY, message }) => {
  const navigate = useNavigate();
  const promptMessage = message || getContactVerificationPromptMessage(role);

  const handleGoToProfile = () => {
    onClose();
    navigate(getContactVerificationProfilePath(role));
  };

  return (
    <Dialog className="family-verification-dialog" open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ className: "family-settings-dialog-paper" }}>
      <DialogContent className="family-settings-dialog-content">
        <IoAlertCircleOutline className="family-verification-dialog-icon" aria-hidden="true" />
        <h2 className="family-settings-dialog-title">Verification required</h2>
        <p className="family-settings-dialog-copy">{promptMessage}</p>
        <p className="family-settings-dialog-subtitle">Go to your profile to verify your contact details.</p>
        <div className="family-verification-dialog-actions">
          <button type="button" className="family-settings-dialog-close family-verification-dialog-primary" onClick={handleGoToProfile}>
            Go to user profile
          </button>
          <button type="button" className="family-verification-dialog-secondary" onClick={onClose}>
            Later
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactVerificationPrompt;
